// removed by extract-text-webpack-plugin
module.exports = {"pgx-form":"pgx-form","material-form":"material-form"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/normal/MaterialForm/materialForm.scss
// module id = 1384
// module chunks = 0